import { useTrack } from "@hackler/react-sdk"
import { useLocation } from "react-router-dom"
import qs from "qs"
import { useCallback } from "react"

export default function useTrackReferralKey() {
  const track = useTrack()
  const { search } = useLocation()
  const queryString = qs.parse(search, { ignoreQueryPrefix: true })

  const source = (queryString["utm_source"] as string ?? "").toLowerCase()
  const prefix = source && "_" + source

  return useCallback(() => {
    if (prefix) {
      track({ key: `homepage_home_view_referral${prefix}` })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
